import "%modules%/header/header";
import "%modules%/intro/intro";
import "%modules%/carousel-of-movies/carousel-of-movies";
import "%modules%/daily-content-deliveries/daily-content-deliveries";
import "%modules%/example-of-api-operation/example-of-api-operation";
import "%modules%/what-data-do-we-provide/what-data-do-we-provide";
import "%modules%/tariffs/tariffs";
import "%modules%/support/support";
import "%modules%/footer/footer"